import { Box, Flex, HStack, Text } from '@chakra-ui/react';
import { useDisclosure } from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';
import { Button } from '@/components/v4';
import TellMeMoreModal from './TellMeMoreModal';

export default function UploadMethodSelector({
    uploadMethod,
    setUploadMethod,
    darkMode,
}) {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <>
            <Box
                border="1px solid"
                borderColor={darkMode ? 'dark.tcap-borderGray' : 'gray.200'}
                borderRadius="md"
                px={4}
                py={3}
                my={4}
                maxW="895px"
                bg={darkMode ? 'dark.tcap' : 'gray.50'}>
                <Flex
                    align="center"
                    justify="space-between"
                    gap={4}
                    flexWrap="wrap">
                    <Box>
                        <Text
                            fontSize="xs"
                            fontWeight="semibold"
                            color={darkMode ? 'gray.400' : 'gray.500'}
                            mb={1}>
                            Upload Method Configuration
                        </Text>
                        <HStack spacing={1} flexWrap="wrap">
                            <Text
                                fontSize="sm"
                                color={darkMode ? 'gray.300' : 'gray.600'}>
                                Choose the method by which your numbers are
                                uploaded to TCAP.
                            </Text>
                            <Button
                                variant="link"
                                size="sm"
                                leftIcon={<InfoIcon boxSize="12px" />}
                                onClick={onOpen}
                                fontWeight="normal"
                                fontSize="sm">
                                Tell me more
                            </Button>
                        </HStack>
                    </Box>

                    {/* Segmented pill toggle — like a List|Grid switcher */}
                    <Box
                        display="inline-flex"
                        borderRadius="full"
                        p="3px"
                        bg={darkMode ? 'gray.700' : 'gray.200'}
                        flexShrink={0}>
                        <Button
                            borderRadius="full"
                            size="sm"
                            px={6}
                            variant={
                                uploadMethod === 'createOrder'
                                    ? 'solid'
                                    : 'ghost'
                            }
                            onClick={() => setUploadMethod('createOrder')}
                            _hover={
                                uploadMethod !== 'createOrder'
                                    ? {
                                          bg: darkMode
                                              ? 'gray.600'
                                              : 'gray.300',
                                      }
                                    : {}
                            }>
                            Create Order
                        </Button>
                        <Button
                            borderRadius="full"
                            size="sm"
                            px={6}
                            variant={
                                uploadMethod === 'liveUpload'
                                    ? 'solid'
                                    : 'ghost'
                            }
                            onClick={() => setUploadMethod('liveUpload')}
                            _hover={
                                uploadMethod !== 'liveUpload'
                                    ? {
                                          bg: darkMode
                                              ? 'gray.600'
                                              : 'gray.300',
                                      }
                                    : {}
                            }>
                            Live Upload
                        </Button>
                    </Box>
                </Flex>
            </Box>

            <TellMeMoreModal
                isOpen={isOpen}
                onClose={onClose}
                darkMode={darkMode}
            />
        </>
    );
}
